// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".heroes-module__containerAccount____jSuL{max-width:200px}.heroes-module__containerAccountMoniker___DGwLV{text-overflow:ellipsis;overflow:hidden}", "",{"version":3,"sources":["webpack://./src/pages/robot/_refactor/account/tabs/heroes.module.scss"],"names":[],"mappings":"AACA,yCACE,eAAA,CAEA,gDACE,sBAAA,CACA,eAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerAccount": "heroes-module__containerAccount____jSuL",
	"containerAccountMoniker": "heroes-module__containerAccountMoniker___DGwLV"
};
export default ___CSS_LOADER_EXPORT___;
